export default __webpack_public_path__ + "static/media/wealth1.ec0f9606.png";